import {
  Send,
  Clock,
  AlertCircle,
  CheckCircle2,
  XCircle,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface StatusConfigEntry {
  icon: LucideIcon;
  color: string;
  bgColor: string;
  dotColor: string;
  label: string;
}

// Status configuration with colors matching the old portal
export const statusConfig: Record<string, StatusConfigEntry> = {
  invited: { icon: Send, color: 'text-blue-700', bgColor: 'bg-blue-100', dotColor: '#3B82F6', label: 'Invited' },
  in_progress: { icon: Clock, color: 'text-yellow-700', bgColor: 'bg-yellow-100', dotColor: '#EAB308', label: 'In Progress' },
  submitted: { icon: AlertCircle, color: 'text-orange-700', bgColor: 'bg-orange-100', dotColor: '#F97316', label: 'Submitted' },
  under_review: { icon: Clock, color: 'text-purple-700', bgColor: 'bg-purple-100', dotColor: '#A855F7', label: 'Under Review' },
  approved: { icon: CheckCircle2, color: 'text-green-700', bgColor: 'bg-green-100', dotColor: '#22C55E', label: 'Approved' },
  rejected: { icon: XCircle, color: 'text-red-700', bgColor: 'bg-red-100', dotColor: '#EF4444', label: 'Rejected' },
  more_info_required: { icon: AlertCircle, color: 'text-amber-700', bgColor: 'bg-amber-100', dotColor: '#F59E0B', label: 'More Info' },
  expired: { icon: XCircle, color: 'text-gray-700', bgColor: 'bg-gray-100', dotColor: '#6B7280', label: 'Expired' },
};
